import { formatMoney } from '@theme/utilities';
import { ThemeEvents } from '@theme/events';

class ProductPrice extends HTMLElement {
  constructor() {
    super();

    this.productForm = null;
  }

  connectedCallback() {
    this.productForm = this.closest('[data-ref="product-section-content"]')?.querySelector('[data-ref="product-form"]');

    document.addEventListener(ThemeEvents.variantUpdated, this.updatePrice);
    document.addEventListener(ThemeEvents.toggleCrossSellsUpdated, this.updatePrice);
    document.addEventListener(ThemeEvents.quantityBreaksUpdated, this.updatePrice);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.variantUpdated, this.updatePrice);
    document.removeEventListener(ThemeEvents.toggleCrossSellsUpdated, this.updatePrice);
    document.removeEventListener(ThemeEvents.quantityBreaksUpdated, this.updatePrice);
  }

  updatePrice = (event) => {
    const currentPriceContainer = this.querySelector('[data-ref="price-container"]');

    let newPriceContainer = currentPriceContainer;
    if (event.detail != null) {
      newPriceContainer = event.detail.data.html.querySelector('product-price [data-ref="price-container"]');
    }

    if (this.productForm != null) {
      const newTotalPrice = this.productForm.getCurrentTotalPrice().price;
      const newTotalCompareAtPrice = this.productForm.getCurrentTotalPrice().compare_at_price;

      const priceElement = newPriceContainer.querySelector('[data-ref="price"]');
      if (priceElement != null) {
        priceElement.innerHTML = formatMoney(newTotalPrice);
      }

      const compareAtPriceElement = newPriceContainer.querySelector('[data-ref="compare-at-price"]');
      if (compareAtPriceElement != null) {
        compareAtPriceElement.innerHTML = '';
        if (newTotalCompareAtPrice > newTotalPrice) {
          compareAtPriceElement.innerHTML = formatMoney(newTotalCompareAtPrice);
        }
      }

      const differencePriceElement = newPriceContainer.querySelector('[data-ref="difference-price-value"]');
      if (differencePriceElement != null) {
        differencePriceElement.innerHTML = '';
      }
    }

    if (!newPriceContainer || !currentPriceContainer) return;

    if (currentPriceContainer.innerHTML !== newPriceContainer.innerHTML) {
      currentPriceContainer.replaceWith(newPriceContainer);
    }
  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}